module.exports = __webpack_public_path__ + "static/media/electrical 1.2d5b7d8a.png";